@if (crmObject() && component) {
  <ng-template [ngComponentOutlet]="component" [ngComponentOutletInputs]="inputs()"></ng-template>
}
